var utilities = {
  cookies: {
    set: function(a, b, c) {
      var d = new Date();
      d.setTime(d.getTime() + 24 * c * 60 * 60 * 1e3);
      var e = "expires=" + d.toUTCString();
      document.cookie = a + "=" + b + "; " + e;
    },
    get: function(a) {
      for (var b = a + "=", c = document.cookie.split(";"), d = 0; d < c.length; d++) {
        for (var e = c[d];
        " " == e.charAt(0);) e = e.substring(1);
        if (0 === e.indexOf(b)) return e.substring(b.length, e.length);
      }
      return "";
    }
  },
  str: {
    ucfirst: function(a) {
      return a.replace(/\w\S*/g, function(a) {
        return a.charAt(0).toUpperCase() + a.substr(1).toLowerCase();
      });
    }
  },
  debounce: function(a, b, c) {
    var d;
    return function() {
      var e = this,
          f = arguments,
          g = function() {
            d = null, c || a.apply(e, f)
          },
          h = c && !d;
      clearTimeout(d), d = setTimeout(g, b), h && a.apply(e, f);
    };
  }
};

export default utilities;



// WEBPACK FOOTER //
// ./scripts/components/utilities.js